<template>
  <generic-modal :title="$t('subarea')" :buttons="buttons" ref="generic_modal">
    <subarea-datatable ref="subarea_datatable" />
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  api_host,
  generate_error_message_text,
  get_currency_settings,
  change_active_tab,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";
import SubareaDatatable from "./SubareaDatatable.vue";

export default {
  name: "SubareaModal",
  components: { GenericModal, SubareaDatatable },
  data() {
    return {
      api_host,
      buttons: [
        // {
        //   text: this.$t("save"),
        //   class: "is-primary is-rounded",
        //   icon: "fa fa-save",
        //   click: this.save,
        //   disabled: "this.is_form_invalid",
        // },
        {
          text: this.$t("close"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return !v.meta.name /* || !v.meta.sale_price */;
    },
  },
  methods: {
    change_active_tab,
    get_currency_settings,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(area_uuid) {
      let v = this;
      v.set_initial_state();
      v.$refs.subarea_datatable.init(area_uuid);
      v.$refs.generic_modal.show_modal();
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        settings: {},
      };
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
